import { useEffect, useState } from "react";
import API from "../../../Network/API";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import SubscribeCard from "../../../components/SubscribeCard";
import { useSelector } from "react-redux";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PLAN_HIGHLIGHTS = [
    { icon: "fa-light fa-video", text: "Create unlimited live classes" },
    { icon: "fa-light fa-users", text: "Host and join unlimited live sessions" },
    { icon: "fa-light fa-hand-holding-dollar", text: "0% commission — keep 100% of every course sale" },
    { icon: "fa-light fa-clapperboard-play", text: "Create and sell recorded courses" },
    { icon: "fa-light fa-address-card", text: "Get featured on the tutor listing" },
];

export default function Subscription() {
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const { user, accessToken } = useSelector((state) => state.authReducer);

    useEffect(() => {
        setLoading(true)
        API.get(`/v1/oauth/teacher/packages`).then((response) => {
            setData(response.data.data.packages)
            setLoading(false)
        }).catch((error) => {
            setLoading(false)
        });

    }, []);


    return (
        <>
            <div className="sub-hero text-center">
                <span className="sub-hero-badge"><i className="fa-light fa-crown me-2" />Room Rent — Monthly Plan</span>
                <h2 className="sub-hero-title">Teach without limits</h2>
                <p className="sub-hero-dec">
                    One monthly subscription unlocks everything you need to grow:
                    unlimited live classes, zero commission on your course sales, and more students finding you.
                </p>
            </div>

            <div className="row justify-content-center">
                <Elements stripe={stripePromise}>

                    {!isLoading && data?.length > 0 && data?.map((pack, j) => (
                        <div className="col-xl-5 col-lg-6 col-md-8" key={j}>
                            <div className="pricing-card">
                                <div className="pricing-card-head">
                                    <h4 className="pricing-card-name">{pack.title}</h4>
                                    <div className="pricing-card-price">
                                        <span className="pricing-amount">${pack.price}</span>
                                        <span className="pricing-period">/month</span>
                                    </div>
                                    {pack.details ? <p className="pricing-card-note">{pack.details}</p> : null}
                                </div>

                                <ul className="list-unstyled pricing-features">
                                    {PLAN_HIGHLIGHTS.map((f, i) => (
                                        <li key={i}>
                                            <span className="pricing-feature-icon"><i className={f.icon} /></span>
                                            <span>{f.text}</span>
                                        </li>
                                    ))}
                                </ul>

                                {user?.is_subscribed ?
                                    <div className="subscribed-panel">
                                        <i className="fa-solid fa-circle-check me-2" />
                                        You're subscribed — enjoy unlimited live classes and 0% commission.
                                    </div>
                                    :
                                    <SubscribeCard priceId={pack.stripe_plan} price={pack.price} />
                                }
                            </div>
                        </div>
                    ))}

                </Elements>
            </div>

            {!user?.is_subscribed &&
                <p className="text-center sub-footnote">
                    Without a subscription you can still sell recorded courses — a platform commission applies to each sale.
                    Cancel anytime; your benefits stay active until the end of the billing period.
                </p>
            }
        </>
    )
}
